import { Injectable, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Jsonp } from '@angular/http';
import { ConfigService } from '../../../utils/config-service';

import { HeatmapModel, HeatmapPoint } from '../models/heatmap.model';
import { Path } from '../../domain/models/spectrogramData';

import * as _ from 'lodash';
import { Polyline } from '../../domain/models/polyline';
import { OverlayToken } from '../../domain/models/overlayToken';
import { Size } from '../../domain/models/size';
import GuidGenerator from '../../../utils/guid-generator';
import 'rxjs/add/operator/map';
import { SpectrogramValue } from '../../domain/models/spectrogramData';


@Injectable()
export class MapsService {
  private googleReady$: Subject<any>;
  private gmap: any;
  private panorama: any = undefined;
  private mapElement: ElementRef;
  private heatmap: any;

  private spectroPolylines: any[];

  private google: any;
  private geocoder: any;
  private directionsDisplay: any;
  private currentRoute: any;

  private currentLocation: any = { lat: 50.844983, lng: 4.352901 };
  private regionBiasBounds: any;
  private clientLocationFound: boolean;

  private directionsChangedObservable: Subject<any>;
  private trafficLayer: any;

  private clickEventObservable: Subject<any>;
  private tempMarkers: Array<any>;

  private streetviewToggled$: Subject<boolean>;
  private streetViewLocation: any;
  private showSearch$: BehaviorSubject<boolean>;

  private focusSearch$: Subject<void>;

  private mapOverlays: Array<any>;

  private cachedPolyLines: Array<Polyline>;

  private overlayTokens: OverlayToken[];
  private currentOverlayToken: OverlayToken;

  private isDrawingRoute: boolean;
  private clearRouteRequested: boolean;
  private showAllRoutes: boolean;

  counter = -1;
  strokeWeight = 5;
  strokeOpacity = 0.5;
  zIndex = 100;
  setRegion;
  private line: any[] = [];
  colors: any[] = [
    '#c80101',
    '#013796',
    '#ff6414',
    '#009102',
    '#3d004d',
    '#ffff00',
    '#1b6efe',
    '#00e604',
    '#b33c00',
    '#fe4d4d',
    '#702602'


  ];
  constructor(private jsonp: Jsonp, private configService: ConfigService) {
    this.directionsChangedObservable = new Subject<any>();
    this.clickEventObservable = new Subject<any>();
    this.streetviewToggled$ = new Subject<boolean>();
    this.focusSearch$ = new Subject<void>();
    this.tempMarkers = [];
    this.clientLocationFound = false;
    this.showSearch$ = new BehaviorSubject<boolean>(false);
    this.mapOverlays = [];
    this.cachedPolyLines = [];
    this.overlayTokens = [];
    this.spectroPolylines = [];
    this.isDrawingRoute = false;
    this.clearRouteRequested = false;
    this.showAllRoutes = false;

    let url = 'https://maps.googleapis.com/maps/api/js?v3.29&key=' + this.configService.getEnv('googleApiKey') + '&libraries=places,visualization,geometry&callback=JSONP_CALLBACK';
    this.googleReady$ = new Subject<any>();
    this.jsonp
      .get(url)
      .retry()
      .subscribe(res => {
        if (res.status === 200) {
          this.googleReady$.complete();
        }
      });
  }

  googleReady(): Observable<any> {
    return this.googleReady$;
  }

  initMap(element: ElementRef): any {
    this.googleReady()
      .subscribe(
        null,
        err => console.log(err),
        () => {
          this.google = (window as any).google;
          this.geocoder = new this.google.maps.Geocoder();
          this.mapElement = element;
          this.gmap = new this.google.maps.Map(element.nativeElement, {
            center: this.currentLocation,
            zoom: 14,
            mapTypeControl: true,
            mapTypeControlOptions: {
              style: this.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
              position: this.google.maps.ControlPosition.TOP_RIGHT
            }
          });

          this.getRegionBiasBounds();

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position: any) => {
              this.currentLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
              this.gmap.setCenter(this.currentLocation);
              this.getRegionBiasBounds();
              this.clientLocationFound = true;
            });
          }

          this.trafficLayer = new this.google.maps.TrafficLayer();
          this.trafficLayer.setMap(this.gmap);

          this.initMapClick();
        });
  }

  initMapClick(): void {
    this.gmap.addListener('click', (event: any) => {
      let location = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      this.clickEventObservable.next(location);
    });
  }

  getRegionBiasBounds(): void {
    let circle = new this.google.maps.Circle({
      center: this.currentLocation,
      radius: 50000
    });
    this.regionBiasBounds = circle.getBounds();
  }

  resizeMap(): any {
    this.google.maps.event.trigger(this.gmap, 'resize');
    if (this.panorama) {
      this.google.maps.event.trigger(this.panorama, 'resize');
    }
  }

  geoCodeAddress(address: string): Promise<any> {
    if (this.clientLocationFound) {
      const promise: Promise<any> = new Promise<any>((result: any) => {
        this.geocoder.geocode({ address: address, bounds: this.regionBiasBounds }, result);
      });
      return promise;
    } else {
      const promise: Promise<any> = new Promise<any>((result: any) => {
        this.geocoder.geocode({ address: address, region: 'BE' }, result);
      });
      return promise;
    }
  }

  reverseGeoCode(latlong: any): Promise<any> {
    let promise: Promise<any> = new Promise<any>((success, failed) => {
      this.geocoder.geocode({ 'location': latlong }, (result, status) => {
        if (status !== 'OK') {
          result = [];
        }
        success(result);
      });
    });
    return promise;
  }

  resetMap() {
    this.clearRoute();
    this.clearTempMarkers();
    this.clearSpectroPolylines();
    this.clearCachedPolyLines();
    this.clearMapOverlays(true);
  }

  drawRoute(startpoint: any, endpoint: any, waypoints: Array<any>): void {
    this.clearRoute();
    this.clearTempMarkers();

    const directionService = new this.google.maps.DirectionsService();
    this.directionsDisplay = new this.google.maps.DirectionsRenderer({
      draggable: true
    });

    this.directionsDisplay.setMap(this.gmap);
    this.directionsDisplay.addListener('directions_changed', () => {
      let route = this.directionsDisplay.getDirections();
      if (route) {
        this.currentRoute = route;
        this.directionsChangedObservable.next(this.currentRoute);
      }
    });

    let waypointsList = [];
    waypoints.forEach(wp => {
      waypointsList.push({ location: wp, stopover: false });
    });

    let directionsRequest = {
      origin: startpoint,
      destination: endpoint,
      waypoints: waypointsList,
      travelMode: 'DRIVING',
      provideRouteAlternatives: false,
      optimizeWaypoints: false
    };

    this.drawRouteByCoordinateDelayed(directionService, directionsRequest, 0, 5, 200);
  }

  private drawRouteByCoordinateDelayed(directionService: any, directionsRequest: any, attempts: number, maxRetries: number, timeout: number): void {
    directionService.route(directionsRequest, (result, status) => {
      setTimeout(() => {
        if (status === 'OK' && this.directionsDisplay) {
          this.directionsDisplay.setDirections(result);
          this.drawingRoutesDone();
          return;
        }
        if (attempts < maxRetries) {
          attempts++;
          this.drawRouteByCoordinateDelayed(directionService, directionsRequest, attempts, maxRetries, timeout);
        }
        this.drawingRoutesDone();
      }, timeout);
    });
  }

  private drawingRoutesDone(): void {
    setTimeout(() => {
      if (this.clearRouteRequested) {
        this.clearRoute();
        this.clearRouteRequested = false;
      }
      this.isDrawingRoute = false;
    }, 500);
  }

  drawPersistedRoute(polyline: Polyline): void {
    let polyData = this.decodePoly(polyline.data);
    let path = new this.google.maps.Polyline({
      path: polyData,
      strokeColor: polyline.strokeColor,
      strokeOpacity: 0.7,
      strokeWeight: 8,
      map: this.gmap
    });
    this.currentRoute = path;
    this.mapOverlays.push(path);
    let originMarker = new this.google.maps.Marker({
      icon: { url: '../../../../assets/marker-A.png', scaledSize: new this.google.maps.Size(30, 45) },
      position: polyline.startpoint,
      map: this.gmap,
      zIndex: this.zIndex,
      visible: true
    });
    this.mapOverlays.push(originMarker);

    let destinationMarker = new this.google.maps.Marker({
      icon: { url: '../../../../assets/marker-B.png', scaledSize: new this.google.maps.Size(30, 45) },
      position: polyline.endpoint,
      map: this.gmap,
      zIndex: this.zIndex,
      visible: true
    });
    this.mapOverlays.push(destinationMarker);
    let bounds = new this.google.maps.LatLngBounds();
    polyData.forEach(element => {
      bounds.extend(element);
    });
    this.gmap.fitBounds(bounds);
    this.gmap.setZoom(14);
  }

  drawSelectedRoutes(polylines: Polyline[]): void {
    this.cachedPolyLines = polylines;
    polylines.forEach(polyline => {
      let polyData = this.decodePoly(polyline.data);
      let middle = Math.floor((polyData.length - 1) / 2);
      let middlePoint = polyData[middle];
      if (polyline.name.length > 20) {
        polyline.name = polyline.name.substring(0, 20) + '...';
      }
      let path = new this.google.maps.Polyline({
        path: polyData,
        strokeColor: polyline.strokeColor,
        strokeOpacity: 0.7,
        strokeWeight: 4,
        map: this.gmap
      });
      this.mapOverlays.push(path);
      let absolute = new URL('../../../../assets/Marker_rectangle.png', window.location.href).href;
      let labelMarker = new this.google.maps.Marker({
        icon: absolute,
        position: middlePoint,
        map: this.gmap,
        label: { text: polyline.name, color: '#fff', fontSize: '12px' },
        visible: true
      });
      this.mapOverlays.push(labelMarker);
    });

  }

  drawPersistedRoutes(polylines: Polyline[]): void {
    this.cachedPolyLines = polylines;
    if (this.showAllRoutes) {
      polylines.forEach(polyline => {
        let polyData = this.decodePoly(polyline.data);
        let middle = Math.floor((polyData.length - 1) / 2);
        let middlePoint = polyData[middle];
        if (polyline.name.length > 20) {
          polyline.name = polyline.name.substring(0, 20) + '...';
        }
        let path = new this.google.maps.Polyline({
          path: polyData,
          strokeColor: polyline.strokeColor,
          strokeOpacity: 0.7,
          strokeWeight: 4,
          map: this.gmap
        });
        this.mapOverlays.push(path);
        let absolute = new URL('../../../../assets/Marker_rectangle.png', window.location.href).href;
        let labelMarker = new this.google.maps.Marker({
          icon: absolute,
          position: middlePoint,
          map: this.gmap,
          label: { text: polyline.name, color: '#fff', fontSize: '12px' },
          visible: true
        });
        this.mapOverlays.push(labelMarker);
      });
    }
  }

  drawPolyLinesForRoutes(polylines: Array<Polyline>): void {
    if (this.currentOverlayToken) {
      this.currentOverlayToken.cancelled = true;
    }

    let overlayToken = new OverlayToken(GuidGenerator.GenerateGuid());
    this.overlayTokens.push(overlayToken);

    this.cacheAndDrawPolyLinesDelayed(polylines, 0, 0, overlayToken);

    this.currentOverlayToken = overlayToken;
  }

  private cacheAndDrawPolyLinesDelayed(polylines: Array<Polyline>, index: number, retries: number, overlayToken: OverlayToken): void {
    if (overlayToken.cancelled) {
      this.removeOverlayTokenById(overlayToken.id);
      return;
    }

    let timeout = 0;
    let newPolyline = polylines[index];
    let cachedPolyLine: any = null;
    if (index < polylines.length) {
      cachedPolyLine = _.find(this.cachedPolyLines, (cp: Polyline) => cp.id === newPolyline.id);

      if (cachedPolyLine) {
        cachedPolyLine.strokeColor = newPolyline.strokeColor;
      } else {
        timeout = 500;
      }
    }

    setTimeout(() => {
      if (index >= polylines.length) {
        this.removeOverlayTokenById(overlayToken.id);
        return;
      }

      if (cachedPolyLine) {
        index++;
        if (this.showAllRoutes) {
          this.drawPolyLine(cachedPolyLine);
        }
        this.cacheAndDrawPolyLinesDelayed(polylines, index, 0, overlayToken);
        return;
      }

      this.cachePolyLine(newPolyline).then((result: any) => {
        if (overlayToken.cancelled) {
          this.removeOverlayTokenById(overlayToken.id);
          return;
        }

        if (result.success && result.data) {
          if (this.showAllRoutes) {
            this.drawPolyLine(result.data);
          } index++;
          retries = 0;
        } else if (!result.success) {
          if (retries < 5) {
            retries++;
          } else {
            retries = 0;
            index++;
          }
        }
        this.cacheAndDrawPolyLinesDelayed(polylines, index, retries, overlayToken);
      });
    }, timeout);
  }

  private removeOverlayTokenById(id: string) {
    _.remove(this.overlayTokens, (ot: any) => ot.id === id);
  }

  private cachePolyLine(polyline: Polyline): Promise<any> {
    return new Promise<any>((resolve) => {
      this.getRoute(polyline.startpoint, polyline.endpoint, polyline.waypoints).then((result: any) => {
        if (result.route && result.status === 'OK') {
          polyline.data = result.route.routes[0].overview_path;

          this.cachedPolyLines.push(polyline);
          resolve({ data: polyline, success: true });
        } else {
          resolve({ success: false });
        }
      });
    });
  }

  getRoute(startpoint: any, endpoint: any, waypoints: any[]): Promise<any> {
    this.removeBranchingLines();
    const promise: Promise<any> = new Promise<any>((success, failed) => {
      let waypointsList = [];
      if (waypoints) {
        waypoints.forEach(wp => {
          waypointsList.push({ location: { lat: wp.y || wp.lat, lng: wp.x || wp.lng }, stopover: false });
        });
      }
      let start = { lat: startpoint.y || startpoint.lat, lng: startpoint.x || startpoint.lng };
      let end = { lat: endpoint.y || endpoint.lat, lng: endpoint.x || endpoint.lng };

      const directionService = new this.google.maps.DirectionsService();
      directionService.route({
        origin: start,
        destination: end,
        waypoints: waypointsList,
        travelMode: 'DRIVING',
        provideRouteAlternatives: false,
        optimizeWaypoints: false
      }, (result, status) => {
        success({ route: result, status: status });
      });
    });
    return promise;
  }

  drawPolyLine(polyline: Polyline): void {
    let middle = Math.floor((polyline.data.length - 1) / 2);
    let middlePoint = polyline.data[middle];
    if (polyline.name.length > 20) {
      polyline.name = polyline.name.substring(0, 20) + '...';
    }
    let path = new this.google.maps.Polyline({
      path: polyline.data,
      strokeColor: polyline.strokeColor,
      strokeOpacity: 0.7,
      strokeWeight: 4,
      map: this.gmap
    });
    this.mapOverlays.push(path);
    let absolute = new URL('../../../../assets/Marker_rectangle.png', window.location.href).href;
    let labelMarker = new this.google.maps.Marker({
      icon: absolute,
      position: middlePoint,
      map: this.gmap,
      label: { text: polyline.name, color: '#fff', fontSize: '12px' },
      visible: true
    });
    this.mapOverlays.push(labelMarker);
  }
  drawBranchingPolylines(polylines, sectionData?) {
    this.counter = -1;
    this.removeBranchingLines();
    let widthCounter = 0;
    polylines.forEach(polyline => {
      widthCounter++;
      if (widthCounter === 1) {
        this.strokeOpacity = 0.7;
        this.strokeWeight = 12;
        this.zIndex = 100;
      } else if (widthCounter === 2) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 11;
        this.zIndex = 200;
      } else if (widthCounter === 3) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 10;
        this.zIndex = 300;
      } else if (widthCounter === 4) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 9;
        this.zIndex = 400;
      } else if (widthCounter === 5) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 8;
        this.zIndex = 500;
      } else if (widthCounter === 6) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 7;
        this.zIndex = 600;
      } else if (widthCounter === 7) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 6;
        this.zIndex = 700;
      } else if (widthCounter === 8) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 5;
        this.zIndex = 800;
      } else if (widthCounter === 9) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 4;
        this.zIndex = 1000;
      } else if (widthCounter === 10) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 4;
        this.zIndex = 1100;
      } else if (widthCounter === 11) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 4;
        this.zIndex = 1200;
      } else if (widthCounter === 12) {
        this.strokeOpacity = 0.5;
        this.strokeWeight = 4;
        this.zIndex = 1300;
      }

      this.zIndex = 100;
      this.counter += 1;
      let decodedPath = this.google.maps.geometry.encoding.decodePath(polyline);
      if (sectionData !== undefined) {
        if (polyline === sectionData[Object.keys(sectionData)[0]]) {
          this.strokeOpacity = 1;
          this.strokeWeight = 6;
          this.zIndex = 300;
        }
      }
      this.setRegion = new this.google.maps.Polyline({
        path: decodedPath,
        strokeColor: this.colors[this.counter],
        strokeOpacity: this.strokeOpacity,
        strokeWeight: this.strokeWeight,
        zIndex: this.zIndex,
        map: this.gmap
      });
      this.line.push(this.setRegion);

      let originMarker = new this.google.maps.Marker({
        icon: { url: '../../../../assets/marker-A.png', scaledSize: new this.google.maps.Size(30, 45) },
        position: decodedPath[0],
        map: this.gmap,
        zIndex: this.zIndex,
        visible: true
      });

      let destinationMarker = new this.google.maps.Marker({
        icon: { url: '../../../../assets/marker-B.png', scaledSize: new this.google.maps.Size(30, 45) },
        position: decodedPath[decodedPath.length - 1],
        map: this.gmap,
        zIndex: this.zIndex,
        visible: true
      });

      this.mapOverlays.push(originMarker);
      this.mapOverlays.push(destinationMarker);
      let bounds = new this.google.maps.LatLngBounds();
      decodedPath.forEach(element => {
        bounds.extend(element);
      });
      this.gmap.fitBounds(bounds);
    });
  }
  removeBranchingLines() {
    if (this.line !== null) {
      for (let i = 0; i < this.line.length; i++) {
        this.line[i].setMap(null); // or line[i].setVisible(false);
      }
    }
  }

  clearMapOverlays(clearCurrentRoute: boolean): void {
    if (clearCurrentRoute) {
      _.each(this.mapOverlays, (element: any) => {
        element.setMap(null);
      });
      this.mapOverlays.length = 0;
    } else {

      _.each(this.mapOverlays, (element: any) => {
        if (this.mapOverlays.indexOf(element) > 2) {
          element.setMap(null);
        }
      });
    }
  }

  clearCachedPolyLines(): void {
    if (this.currentOverlayToken) {
      this.currentOverlayToken.cancelled = true;
    }
    this.cachedPolyLines = [];
  }

  getCurrentRoute(): any {
    return this.currentRoute;
  }

  getCurrentRouteLength(): number {
    return this.getRouteLength(this.currentRoute);
  }

  getRouteLength(route: any): number {
    let totalDistance = 0;
    if (route && route.routes) {
      let legs = route.routes[0].legs;
      for (let i = 0; i < legs.length; ++i) {
        totalDistance += legs[i].distance.value;
      }
    }
    return totalDistance;
  }

  clearRoute(): void {
    if (this.directionsDisplay != null) {
      this.directionsDisplay.setMap(null);
      this.directionsDisplay = null;
    }

    this.currentRoute = null;
  }

  clearRouteDelayed(): void {
    if (this.isDrawingRoute) {
      if (!this.clearRouteRequested) {
        this.clearRouteRequested = true;
      }
      return;
    }
    this.clearRoute();
  }

  clearTempMarkers(): void {
    _.each(this.tempMarkers, (marker: any) => {
      marker.setMap(null);
    });
    this.tempMarkers = [];
  }

  getDirectionsChangedObservable(): Observable<any> {
    return this.directionsChangedObservable;
  }

  toggleTrafficLayer(showTraffic: boolean): void {
    if (showTraffic) {
      this.trafficLayer.setMap(this.gmap);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

  toggleAllRoutesLayer(showAllRoutes: boolean): void {
    this.showAllRoutes = showAllRoutes;
    let currentCached = this.cachedPolyLines;
    if (showAllRoutes) {
      this.drawPersistedRoutes(this.cachedPolyLines);
    } else {
      this.clearMapOverlays(false);
    }
  }

  centermap(coords: any): void {
    this.gmap.setCenter(coords);
  }

  getClickEventObservable(): Observable<any> {
    return this.clickEventObservable;
  }

  setTempMarker(markerUrl: string, size: Size, location: any): void {
    let icon = {
      url: markerUrl, // url
      scaledSize: new this.google.maps.Size(size.width, size.height), // scaled size
      origin: new this.google.maps.Point(0, 0), // origin
    };

    let marker = new this.google.maps.Marker({
      position: location,
      map: this.gmap,
      icon: icon
    });
    this.tempMarkers.push(marker);
  }

  checkStreetViewAvailability(location: any): Observable<boolean> {
    return Observable.create(observer => {
      let gstService = new this.google.maps.StreetViewService();
      return gstService.getPanorama({
        location: location,
        source: this.google.maps.StreetViewSource.OUTDOOR
      }, (data, status) => {
        if (status === this.google.maps.StreetViewStatus.OK) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      });
    });
  }
  splitStreetView(location: any): void {
    this.streetViewLocation = location;
    this.streetviewToggled$.next(true);
  }
  closeSplitStreetView(): void {
    this.streetviewToggled$.next(false);
  }

  enableSplit(element: ElementRef): void {
    if (this.panorama) {
      this.panorama.setPosition(this.streetViewLocation);
    } else if (element.nativeElement.className !== 'closed') {
      this.panorama = new this.google.maps.StreetViewPanorama(element.nativeElement, {
        position: this.streetViewLocation
      });
      this.gmap.setStreetView(this.panorama);
    }
    if (element.nativeElement.className !== 'closed') {
      this.gmap.getStreetView().setVisible(true);
    }
  }

  disableSplit(): void {
    this.panorama = undefined;
    let pan = new this.google.maps.StreetViewPanorama(this.mapElement.nativeElement, {
      position: this.streetViewLocation,
      enableCloseButton: true
    });
    this.gmap.setStreetView(pan);
    this.gmap.getStreetView().setVisible(false);
  }
  getStreetViewToggledObservable(): Observable<boolean> {
    return this.streetviewToggled$;
  }

  enableSearch(): void {
    this.showSearch$.next(true);
  }

  disableSearch(): void {
    this.showSearch$.next(false);
  }
  bindSearch(searchElement: ElementRef) {
    this.initAutoComplete(searchElement);
  }
  unbindSearch(): void {
    if (this.gmap) {
      this.gmap.controls[this.google.maps.ControlPosition.TOP_CENTER].clear();
    }
  }

  getshowSearch$(): Observable<boolean> {
    return this.showSearch$;
  }

  focusSearch(): void {
    this.focusSearch$.next();
  }

  getFocusSearch(): Observable<void> {
    return this.focusSearch$;
  }

  initAutoComplete(searchbox: ElementRef): void {
    if (!searchbox) { return; }

    let div = searchbox.nativeElement;
    let input = searchbox.nativeElement.querySelector('input.search-box');
    let search = new this.google.maps.places.SearchBox(input);
    this.gmap.controls[this.google.maps.ControlPosition.TOP_CENTER].push(div);

    this.gmap.addListener('bounds_changed', () => {
      search.setBounds(this.gmap.getBounds());
    });

    let markers = [];
    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    search.addListener('places_changed', () => {
      let places = search.getPlaces();

      if (places.length === 0) {
        return;
      }

      // Clear out the old markers.
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markers = [];

      // For each place, get the icon, name and location.
      let bounds = new this.google.maps.LatLngBounds();
      places.forEach((place) => {
        if (!place.geometry) {
          console.log('Returned place contains no geometry');
          return;
        }
        let icon = {
          url: place.icon,
          size: new this.google.maps.Size(71, 71),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(17, 34),
          scaledSize: new this.google.maps.Size(25, 25)
        };

        // Create a marker for each place.
        markers.push(new this.google.maps.Marker({
          map: this.gmap,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }));

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.gmap.fitBounds(bounds);
    });
  }

  drawHeatmap(heatmapModel: HeatmapModel): void {
    let mapData = [];
    _.each(heatmapModel.points, (point: HeatmapPoint) => {
      mapData.push({
        location: new this.google.maps.LatLng(point.lat, point.lng),
        weight: point.weight + 1
      });
    });

    if (!this.heatmap) {
      this.heatmap = new this.google.maps.visualization.HeatmapLayer();
    }
    this.heatmap.setData(mapData);
    this.heatmap.setOptions({
      maxIntensity: heatmapModel.maxWeight,
      opacity: 1,
      dissipating: true,
      radius: 40,
    });

    this.heatmap.setMap(this.gmap);
  }

  drawSpectrogramOnMap(path: Array<Path>, data: SpectrogramValue, maxValue: number, colorScale: any[], type: string): void {
    this.clearMapOverlays(true);
    let bounds = new this.google.maps.LatLngBounds();
    if (data && data.values) {
      for (let i = 0; i < path.length; i++) {
        let segment = [];
        path[i].locations.forEach(location => {
          segment.push({ lat: location.y, lng: location.x });
        });
        if (data.values[i]) {
          let colorIndex = Math.floor(colorScale.length / maxValue * data.values[i][type]);
          if (colorIndex >= colorScale.length) {
            colorIndex = colorScale.length - 1;
          }
          let color = colorScale[colorIndex];

          let polyline = new this.google.maps.Polyline({
            path: segment,
            strokeColor: color.color,
            strokeOpacity: 1,
            strokeWeight: 6,
            map: this.gmap
          });

          this.spectroPolylines.push(polyline);
          segment.forEach(element => {
            bounds.extend(element);
          });
        }
      }
      this.gmap.fitBounds(bounds);
    }
  }

  clearSpectroPolylines(): void {
    if (this.spectroPolylines && this.spectroPolylines.length > 0) {
      this.spectroPolylines.forEach((polyline: any) => {
        polyline.setMap(null);
      });
      this.spectroPolylines.length = 0;
    } else {
      this.spectroPolylines = [];
    }
  }

  haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number) {
    function toRad(x) {
      return x * Math.PI / 180;
    }

    let R = 6371; // km

    let x1 = lat2 - lat1;
    let dLat = toRad(x1);
    let x2 = lng2 - lng1;
    let dLon = toRad(x2);
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;

    return d * 1000;
  }
  decodePoly(encoded: any): any {
    return this.google.maps.geometry.encoding.decodePath(encoded);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps/services/maps.service.ts